import React from "react";

export default function Legal() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-24 text-gray-900 font-sans space-y-10">

      <h1 className="text-3xl font-bold">Privacy Policy</h1>
      <p>
        This Privacy Policy describes how Africa Loud ("we", "us" or "our")
        collects, uses, stores, protects and discloses your personal
        information when you use our website or services, in compliance with
        South African law, specifically the Protection of Personal Information
        Act No. 4 of 2013 ("POPIA").
      </p>

      <h2 className="text-2xl font-semibold">1. Information We Collect</h2>
      <p>
        We may collect personal information you voluntarily provide, including
        your name, email address, company name and any other data you submit
        via forms or email.
      </p>

      <h2 className="text-2xl font-semibold">2. How We Use Your Information</h2>
      <p>
        We use your personal information to respond to enquiries, provide
        services, improve our website and services, and communicate updates. We
        will not process personal information beyond what is necessary for the
        purposes for which it was collected.
      </p>

      <h2 className="text-2xl font-semibold">3. Legal Basis for Processing</h2>
      <p>
        We process personal information lawfully, specifically to perform our
        contractual obligations to you, to comply with legal requirements, and
        as necessary to pursue our legitimate interests in operating our
        services.
      </p>

      <h2 className="text-2xl font-semibold">4. Data Security</h2>
      <p>
        We implement reasonable technical and organisational measures to
        safeguard your personal information from unauthorised access,
        disclosure, or misuse.
      </p>

      <h2 className="text-2xl font-semibold">5. Sharing and Disclosure</h2>
      <p>
        We will not share your personal information with third parties except
        where required to provide services, comply with law, or with your
        consent.
      </p>

      <h2 className="text-2xl font-semibold">6. Your Rights Under POPIA</h2>
      <p>
        You have the right to access, correct, update, or delete your personal
        information, and to object to or restrict processing. You may also
        withdraw consent where it was provided.
      </p>

      <h2 className="text-2xl font-semibold">7. Contact Information</h2>
      <p>
        For privacy enquiries, please contact us at:
        <br />
        <strong>Email:</strong> contact@africaloudmag.com
      </p>

      <hr className="border-t my-8" />

      <h1 className="text-3xl font-bold">Terms of Service</h1>

      <h2 className="text-2xl font-semibold">1. Acceptance of Terms</h2>
      <p>
        By accessing or using our website and services, you agree to these
        Terms of Service. If you do not agree, you should not use our services.
      </p>

      <h2 className="text-2xl font-semibold">2. Use of Our Services</h2>
      <p>
        You agree not to misuse our services, including activities that may
        harm, disrupt or infringe the rights of others. You also agree not to
        attempt to gain unauthorised access to restricted content.
      </p>

      <h2 className="text-2xl font-semibold">3. Intellectual Property</h2>
      <p>
        All content, trademarks, and data on the Africa Loud platform are
        owned or licensed by us, and protected by applicable intellectual
        property laws.
      </p>

      <h2 className="text-2xl font-semibold">4. Limitation of Liability</h2>
      <p>
        We will not be liable for indirect, special, incidental, or
        consequential losses arising from your use of our services.
      </p>

      <h2 className="text-2xl font-semibold">5. Governing Law</h2>
      <p>
        These Terms are governed by the laws of South Africa, including POPIA and
        the Electronic Communications and Transactions Act.
      </p>

      <h2 className="text-2xl font-semibold">6. Changes to Terms</h2>
      <p>
        We may update these Terms from time to time. Continued use of our
        services after changes signifies acceptance.
      </p>

      <h2 className="text-2xl font-semibold">Contact</h2>
      <p>
        For any questions about these Terms or your rights, contact us at:
        <br />
        <strong>Email:</strong> contact@africaloudmag.com
      </p>

    </div>
  );
}
